var map = {
	"./monthly-semester-mapping/locales/en.json": "95eb",
	"./monthly-semester-mapping/locales/kh.json": "139f",
	"./score-copy/locales/en.json": "babf",
	"./score-copy/locales/kh.json": "c7ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43e2";